<template>
    <div>
        <Tag :isOpt="true"/>
    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import Tag from './Tag.vue'

  export default {
    name: 'TagList',
    props:{

    },
    data() {
      return {


      }
    },
    components: {
      Tag
    },
    mounted() {
    },
    methods: {

      //添加子标签

    },

  }
</script>
<style type="stylus" scope>
    .list-item{
        padding: 5px 0px;
    }
</style>




// WEBPACK FOOTER //
// src/main/admin/TagList.vue